import { AlertBanner } from '@momentum-ui/react'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

const PortalDeprecationAlert: React.FC = () => {
  const { t } = useTranslation()
  const [showPortalDeprecationAlert, setShowPortalDeprecationAlert] = useState(
    true
  )

  return (
    <AlertBanner
      show={showPortalDeprecationAlert}
      type="warning"
      closable
      onHide={(): void => setShowPortalDeprecationAlert(false)}
      onKeyDownClose={(): void => setShowPortalDeprecationAlert(false)}
    >
      <div>{t('generalDocumentation.portalDeprecationText')}</div>
      <a
        href="https://developer.webex.com/"
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('generalDocumentation.developerPortalLinkText')}
      </a>
    </AlertBanner>
  )
}

export default PortalDeprecationAlert
